import StickyHeader from './StickyHeader.ts';
import './Animations.ts';
import Menu from './Menu.ts';
import HeroSlider from './HeroSlider.ts';
import Carousel from './Carousel.ts';

/**
 * Remove 'no-js' body class
 */

document.body.classList.remove('no-js');

/**
 * Init Menu
 */

new Menu(document.querySelector('#menu-toggle'), document.querySelector('.main-navigation'));

/**
 * Init StickyHeader
 */

new StickyHeader(document.querySelector('.site-header'));

/**
 * Init Hero Slider
 */

new HeroSlider(document.querySelector('.hero'));

/**
 * Init Carousels 
 */

 const carousels = document.querySelectorAll('.carousel');
 if(carousels){
     carousels.forEach(carousel => new Carousel(carousel as HTMLElement));
 }